import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useActiveMembership } from '@/features/session/useActiveMembership';
import { useTourStore } from './store';
import { TOURS } from './tours';
import { visibleTours } from './types';

// Auto-runs a page's tour the first time that page is opened, for the tours
// that declare an `autoRoute`. Desktop only:
// the page tours anchor on the sidebar nav links, which are replaced by the
// bottom tab bar below `md`, so on a phone every one of those steps would sit
// on a missing anchor.
export function useAutoPageTour() {
  const { pathname } = useLocation();
  const { membership } = useActiveMembership();
  const role = membership?.role;
  const activeTourId = useTourStore((s) => s.activeTourId);
  const completed = useTourStore((s) => s.completed);
  const startTour = useTourStore((s) => s.startTour);
  const markSeen = useTourStore((s) => s.markSeen);

  useEffect(() => {
    if (!membership || activeTourId) return;
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    const tour = visibleTours(TOURS, role).find((candidate) => candidate.autoRoute === pathname);
    if (!tour || completed.includes(tour.id)) return;
    markSeen(tour.id);
    startTour(tour.id);
  }, [pathname, membership, role, activeTourId, completed, startTour, markSeen]);
}
